import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { ADMIN_COLORS } from '@/constants/admin';
import { formatCurrency } from '@/utils/common/formatting';
import { ITransactionSummary } from '@/types/admin/transactions';

interface TransactionSummaryProps {
  summary: ITransactionSummary;
}

export const TransactionSummary: React.FC<TransactionSummaryProps> = ({ summary }) => {
  const balanceColor = summary.currentBalance > 0 
    ? ADMIN_COLORS.TRANSACTION.CHARGE 
    : summary.currentBalance < 0 
    ? ADMIN_COLORS.TRANSACTION.PAYMENT 
    : ADMIN_COLORS.TEXT_PRIMARY;

  return (
    <View style={styles.container}>
      <View style={styles.card}>
        <Text style={styles.label}>Total Charges</Text>
        <Text style={[styles.value, { color: ADMIN_COLORS.TRANSACTION.CHARGE }]}>
          {formatCurrency(summary.totalCharges)}
        </Text>
      </View>

      <View style={styles.card}>
        <Text style={styles.label}>Total Payments</Text>
        <Text style={[styles.value, { color: ADMIN_COLORS.TRANSACTION.PAYMENT }]}>
          {formatCurrency(summary.totalPayments)}
        </Text>
      </View>

      <View style={[styles.card, styles.balanceCard]}>
        <Text style={styles.label}>Current Balance</Text>
        <Text style={[styles.value, styles.balanceValue, { color: balanceColor }]}>
          {formatCurrency(summary.currentBalance)}
        </Text>
        <Text style={styles.subLabel}>
          {summary.currentBalance > 0 ? 'Amount Owed' : summary.currentBalance < 0 ? 'Credit Balance' : 'Paid in Full'}
        </Text>
      </View>

      <View style={styles.card}>
        <Text style={styles.label}>Transactions</Text>
        <Text style={styles.value}>{summary.transactionCount}</Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    gap: 16,
    padding: 16,
    backgroundColor: ADMIN_COLORS.BACKGROUND.PRIMARY,
    borderBottomWidth: 1,
    borderBottomColor: ADMIN_COLORS.BORDER,
  },
  card: {
    flex: 1,
    padding: 16,
    backgroundColor: ADMIN_COLORS.BACKGROUND.SECONDARY,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: ADMIN_COLORS.BORDER,
  },
  balanceCard: {
    borderColor: ADMIN_COLORS.PRIMARY + '40',
    borderWidth: 2,
  },
  label: {
    fontSize: 12,
    fontWeight: '500',
    color: ADMIN_COLORS.TEXT_SECONDARY,
    textTransform: 'uppercase',
    letterSpacing: 0.5,
    marginBottom: 8,
  },
  value: {
    fontSize: 24,
    fontWeight: '700',
    color: ADMIN_COLORS.TEXT_PRIMARY,
  },
  balanceValue: {
    fontSize: 28,
  },
  subLabel: {
    fontSize: 11,
    color: ADMIN_COLORS.TEXT_SECONDARY,
    marginTop: 4,
  },
});

